import React, { useState, useEffect, useReducer } from 'react'
import { Panel, Row, Col, Table } from 'rsuite'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import { isSupportFileByNameType } from '../../utils/ValidatorUtils'
import moment from 'moment'
import { getTaxWaiteSend, getExpensesAttachments } from '../../redux/actions/accountingExpenses'
import { DEFAULT_ERR_MSG, ERR_MSG } from '../../constants/msgText'
import notification from '../../utils/notification'
import { startLoading, doneLoading } from '../../utils/loading'
import IncomeRecordFileTable from '../../widgets/incomeRecordWidget/IncomeRecordFileTable'
import { downloadFile, previewFile } from '../../utils/fileUtil'
import { sessionGetItemJSON } from '../../utils/sessionHelpers'
import { getConvertDateTimeToThaiShort, getValueFromOptions } from '../../utils/dataUtil'

export default function ExpenseRecordView({
  schema: _schema,
  register,
  errors,
  error,
  Controller,
  control,
  setValue,
  clearErrors,
  getValues,
  onSelectWaitSendTax = () => {},
  formTableDatas,
  ...props
}) {
  const triggerRef = React.useRef()
  const { Column, HeaderCell, Cell } = Table
  const [formSchema, setFormSchema] = useState(_schema)
  const [valueAccChannel, setValueAccChannel] = useState(_schema.accountChannel.value || 0)
  const [showPendingTaxList, setShowPendingTaxList] = useState(false)

  const [fileList, setFileList] = useState([])

  const [supportFileError, setSupportFileError] = useState(false)
  const [isOverSize, setIsOverSize] = useState(false)
  const [isNotSupportType, setIsNotSupportType] = useState(false)

  const [waitSendTaxSchema, setWaitSendTaxSchema] = useState()

  const [waitSendTaxType, setWaitSendTaxType] = useState()
  const [waitSendTaxMount, setWaitSendTaxMount] = useState()
  const [errorSearchTaxWaiteSend, setErrorSearchTaxWaiteSend] = useState()

  const [receivedFromSchema, setReceivedFromSchema] = useState()
  const [searchNameOrId, setSearchNameOrId] = useState()
  const [fileTableData, setFileTableData] = useState(_schema?.attachFiles?.values || [])

  const [checkedAll, setCheckedAll] = useState(false)
  const [indeterminate, setIndeterminate] = useState(false)
  const [checkedKeys, setCheckedKeys] = useState([])
  const [waitSendTaxSelected, setWaitSendTaxSelected] = useState([])

  const [tempCheckedAll, setTempCheckedAll] = useState(false)
  const [tempIndeterminate, setTempIndeterminate] = useState(false)
  const [tempSendTaxSelected, setTempSendTaxSelected] = useState([])
  const [tempCheckedKeys, setTempCheckedKeys] = useState([])

  const [disabledSendTax, setDisabledSendTax] = useState(false)

  const [_, forceUpdate] = useReducer((x) => x + 1, 0)
  const projectCode = sessionStorage.getItem('projectCode')
  const periodInfo = sessionGetItemJSON('periodInfo')

  const defaultSupportType = '.jpg, .jpeg, .png, .pdf'

  useEffect(() => {
    if (formTableDatas && formTableDatas.length > 0) {
      let index = formTableDatas.findIndex((item) => item.id.indexOf('addNew') > -1)
      if (index > -1) {
        if (formTableDatas[index]?.id?.indexOf('sendTax') > -1) {
          setDisabledSendTax(false)
        } else {
          setDisabledSendTax(true)
        }
      } else {
        setDisabledSendTax(false)
      }
    }
  }, [formTableDatas])

  const onDownload = async (fileObj) => {
    startLoading()
    try {
      var file = await getExpensesAttachments(fileObj.id)
      var fileName = fileObj.label

      downloadFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'ดาวน์โหลด ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    doneLoading()
  }

  const onPreview = async (fileObj) => {
    startLoading()
    try {
      var file = await getExpensesAttachments(fileObj.id)
      var fileName = fileObj.name

      previewFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'แสดง ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    doneLoading()
  }

  return (
    <>
      <Panel
        bordered
        style={{
          marginTop: 25,
          border: '1px solid #4e4b488c',
        }}
        header={
          periodInfo && (
            <div style={{ textAlign: 'left' }}>
              <Col lg={12} md={12} sm={24} xs={24}>
                {formSchema.header || (
                  <span>{periodInfo?.periodNo + ' (' + periodInfo?.startAndEndDate + ')'}</span>
                )}
              </Col>
              <Col lg={12} md={12} sm={24} xs={24} style={{ textAlign: 'right' }}>
                <span>
                  {'งวดที่ ' + periodInfo?.periodNumber + '/' + periodInfo?.periodOfLength}
                </span>
              </Col>
            </div>
          )
        }
      >
        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {formSchema.payTypeOptions.label}
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <p>{` : ${getValueFromOptions(
              formSchema.payTypeOptions.options,
              formSchema.payTypeOptions.value || '1'
            )}`}</p>
          </Col>

          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {formSchema.voucherNumber.label}
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <p>{` : ${formSchema.voucherNumber.value || 'P-YY-XXXXX'}`}</p>
          </Col>

          <Row>
            <Col
              lg={4}
              md={4}
              sm={24}
              xs={24}
              style={{ textAlign: 'right', marginTop: 10, marginBottom: 20 }}
            >
              {formSchema.referenceNumber.label}
            </Col>
            <Col lg={8} md={8} sm={24} xs={24} style={{ marginTop: 10, marginBottom: 20 }}>
              <p>{` : ${formSchema.referenceNumber.value || ''}`}</p>
            </Col>
          </Row>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {formSchema.accountChannel.label}
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <p>{` : ${getValueFromOptions(
              formSchema.accountChannel.options,
              formSchema.accountChannel.value || '1'
            )}`}</p>
          </Col>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {formSchema.voucherDate.label}
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <p>{` : ${getConvertDateTimeToThaiShort(formSchema.voucherDate.value)}`}</p>
          </Col>
        </Row>

        {valueAccChannel == 2 && formSchema?.bankInput && (
          <Row>
            <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
              {formSchema.bankInput.label}
            </Col>
            <Col lg={20} md={20} sm={24} xs={24}>
              <p>{` : ${getValueFromOptions(
                formSchema.bankInput.options,
                formSchema.bankInput.value
              )}`}</p>
            </Col>
          </Row>
        )}

        {valueAccChannel == 3 && (
          <Row>
            <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
              {formSchema.checkDocNumber.label}
            </Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              <p>{` : ${formSchema.checkDocNumber.value || ''}`}</p>
            </Col>
          </Row>
        )}

        {valueAccChannel == 3 && (
          <Row style={{ marginTop: 10, marginBottom: 10, textAlign: 'right' }}>
            <Col lg={4} md={4} sm={24} xs={24}>
              {formSchema.checkDocDate.label}
            </Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              {/* เช็คกรณีที่ มี datetime */}
              {formSchema.checkDocDate.value.length >= 10
                ? getConvertDateTimeToThaiShort(formSchema.checkDocDate.value)
                : getDateThaiShort(formSchema.checkDocDate.value)}
            </Col>
          </Row>
        )}

        <Row style={{ marginTop: 5 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {formSchema.description.label}
          </Col>
          <Col lg={20} md={20} sm={24} xs={24}>
            <p>{` : ${formSchema.description.value || ''}`}</p>
          </Col>
        </Row>

        <Row style={{ marginTop: 25 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {formSchema.attachFiles.label || 'เอกสารแนบประกอบ'} {' : '}
          </Col>
          <Col lg={20} md={20} sm={24} xs={24}>
            {fileTableData.length > 0 && (
              <IncomeRecordFileTable
                data={fileTableData}
                deleteable={false}
                onPreview={onPreview}
                onDownload={onDownload}
              />
            )}
          </Col>
        </Row>
      </Panel>
    </>
  )
}
